// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"227":"6f12fcc4","320":"fd918b74","385":"f3d0004e","583":"1f24fdd1","671":"7d07dbed","867":"dbb414b3"}[chunkId] + ".chunk.css";
};